import { Span, SpanProcessor } from "@opentelemetry/sdk-trace-base";

import { injectGlobalSpanAttributes } from "../utils/globalSpanAttributes";
import { log, warn } from "../utils/logger";
import { injectSessionAttributes, injectUserAttributes } from "./utils";

const emitProcessorLog = (
  message: string,
  attributes: Record<string, unknown> = {},
) => {
  log({
    message,
    attributes: {
      "l9rum.session.component": "SessionSpanProcessor",
      ...attributes,
    },
  });
};

export class SessionSpanProcessor implements SpanProcessor {
  constructor() {
    emitProcessorLog("[L9RUM Sessions] SessionSpanProcessor initialized");
  }

  onStart(span: Span): void {
    try {
      injectSessionAttributes(span);
    } catch (err) {
      warn({
        message: "[L9RUM Sessions] Failed to inject session attributes", 
        attributes: {
          "l9rum.session.component": "SessionSpanProcessor",
          "l9rum.session.guard": "inject_session",
        },
        error: err,
      });
    }
    try {
      injectUserAttributes(span);
    } catch (err) {
      warn({
        message: "[L9RUM Sessions] Failed to inject user attributes",
        attributes: {
          "l9rum.session.component": "SessionSpanProcessor",
          "l9rum.session.guard": "inject_user",
        },
        error: err,
      });
    }
    try {
      injectGlobalSpanAttributes(span);
    } catch (err) {
      warn({
        message: "[L9RUM Sessions] Failed to inject global span attributes",
        attributes: {
          "l9rum.session.component": "SessionSpanProcessor",
          "l9rum.session.guard": "inject_global_attributes",
        },
        error: err,
      });
    }
  }

  onEnd(): void {}

  shutdown(): Promise<void> {
    emitProcessorLog("[L9RUM Sessions] SessionSpanProcessor shutdown", {
      "l9rum.session.phase": "shutdown",
    });
    return Promise.resolve();
  }

  forceFlush(): Promise<void> {
    emitProcessorLog("[L9RUM Sessions] SessionSpanProcessor forceFlush", {
      "l9rum.session.phase": "force_flush",
    });
    return Promise.resolve();
  }
}
